<template>
  <div class="">
    <div class="box-content--header container align-items-center justify-content-center hidden">
      <div class="box-content--header__img">
        <div class="img1 container align-items-center justify-content-center animation-bottom">
          <div class="img2 container align-items-center justify-content-center">
            <img src="@/assets/img/video-heart.svg" width="50" alt="Minds" class="">
          </div>
        </div>
      </div>
      <div class="box-content--header__text flex-grow-1 flex-basis-400">
        <div class="container">
          <h2 class="animation-top animation-delay-02">{{ $store.getters['isReview'] ? 'REVIEW' : 'YOUR' }} <span>UNITS</span></h2>
          <div class="margin-left-20 margin-right-10 container aling-items-end animation-top animation-delay-04">
            <button style="color: rgb(196, 0, 60);" class="btn btn-sm btn-rounded gradient-yellow btn-padding" @click="$router.go(-1)">Voltar</button>
          </div>
        </div>
        <hr style="width: 167px;" class="header-text-hr animation-top animation-delay-02">
        <p class="animation-bottom animation-delay-04">Aqui você encontra todas unidades de seu book! </p>
      </div>
    </div>
    <div class="box-content shadow-box box-content-border">
      <unidades :data="units" />
    </div>
  </div>
</template>

<script type="text/javascript">
  import { mapGetters } from 'vuex'

  import unidades from '@/components/units'

  export default {
    computed: {
      ...mapGetters({
        student: 'student/GET',
        bookUnits: 'unit/getAll',
        teensUnits: 'teens/GET_UNITS'
      }),
      units () {
        const units = !this.student.teens ? this.bookUnits : this.teensUnits
        
        const copyUnits = units.slice()
        const parsed = copyUnits.map(unit => {
          let unitCopy = {
            _id: unit._id,
            ead: unit.ead,
            number: unit.number,
            score: unit.score,
            finished: unit.finished
          }

          switch (unitCopy.number % 3) {
            case 0:
              unitCopy.cor1 = '#E12F67'
              unitCopy.cor2 = '#8D00FF'
              break
            case 1:
              unitCopy.cor1 = '#00F0FF'
              unitCopy.cor2 = '#6FBE15'
              break
            case 2:
              unitCopy.cor1 = '#FF9C00'
              unitCopy.cor2 = '#FF0000'
              break
            default:
              break
          }
          return {...unitCopy}
        })
        return [...parsed]
      }
    },
    components: {
      unidades
    },
    async mounted () {
      if (!this.student.teens)
        await this.$store.dispatch('unit/setUnit')
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/library/units/units.vue